import { create } from "zustand";

type TCaseFrameLeaveGuardStore = {
  isDirty: boolean;
  pendingLeave: (() => void) | null;
  setDirty: (isDirty: boolean) => void;
  setPendingLeave: (pendingLeave: (() => void) | null) => void;
};

export const useCaseFrameLeaveGuard = create<TCaseFrameLeaveGuardStore>((set) => ({
  isDirty: false,
  pendingLeave: null,
  setDirty: (isDirty) => set({ isDirty }),
  setPendingLeave: (pendingLeave) => set({ pendingLeave })
}));
